import { render, staticRenderFns } from "./heading.vue?vue&type=template&id=f7281942&scoped=true&lang=pug&"
import script from "./heading.vue?vue&type=script&lang=coffee&"
export * from "./heading.vue?vue&type=script&lang=coffee&"
import style0 from "./heading.vue?vue&type=style&index=0&id=f7281942&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7281942",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AccessibilityBtn: require('/opt/build/repo/library/components/globals/accessibility-btn.vue').default})
